import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { StatusPill, PROJECT_STATUSES, fmtDate } from './TasksCommon';
import './Tasks.css';

export default function TasksDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await api.getTasksDashboard();
        setData(res.data);
      } catch (e) {
        setErr(e.response?.data?.detail || e.message);
      }
      setLoading(false);
    })();
  }, []);

  if (loading) return <div className="tasks-page">Загрузка…</div>;
  if (err) return <div className="tasks-page"><div className="tasks-empty">{err}</div></div>;

  const c = data.counters;

  return (
    <div className="tasks-page">
      <h1>Проекты и задачи — сводка</h1>

      <div className="tasks-toolbar">
        <Link to="/tasks/projects" className="tasks-btn primary">Все проекты</Link>
        <Link to="/tasks/teams" className="tasks-btn">Команды</Link>
        <Link to="/tasks/my" className="tasks-btn">Мои задачи</Link>
        <Link to="/tasks/automations" className="tasks-btn">⚙ Автоматизации</Link>
        <Link to="/tasks/resource-load" className="tasks-btn">👥 Загрузка сотрудников</Link>
      </div>

      <div className="tasks-dashboard-counters">
        <div className="tasks-counter-card"><div className="val">{c.total}</div><div className="lbl">Всего активных задач</div></div>
        <div className="tasks-counter-card"><div className="val">{c.new}</div><div className="lbl">Новых</div></div>
        <div className="tasks-counter-card progress"><div className="val">{c.in_progress}</div><div className="lbl">В работе</div></div>
        <div className="tasks-counter-card"><div className="val">{c.review}</div><div className="lbl">На проверке</div></div>
        <div className="tasks-counter-card done"><div className="val">{c.done}</div><div className="lbl">Завершено</div></div>
        <div className="tasks-counter-card overdue"><div className="val">{c.overdue}</div><div className="lbl">Просрочено</div></div>
        {c.deadline_missed !== undefined && (
          <div className="tasks-counter-card" style={{ borderLeft: '4px solid #b91c1c', background: '#fff1f2' }}>
            <div className="val" style={{ color: '#b91c1c' }}>{c.deadline_missed}</div>
            <div className="lbl">⚠ Нарушение дедлайна</div>
          </div>
        )}
      </div>

      <div className="tasks-dashboard-grid">
        <div className="tasks-panel">
          <h3>Загрузка сотрудников (топ-10)</h3>
          {data.workload.length === 0 && <div className="tasks-empty">Нет активных задач</div>}
          {data.workload.map((w) => (
            <div className="workload-row" key={w.user_id}>
              <span>{w.user_name || 'Пользователь'}</span>
              <span>
                {w.active} задач
                {w.overdue > 0 && <span className="badge-overdue">({w.overdue} просрочено)</span>}
              </span>
            </div>
          ))}
        </div>

        <div className="tasks-panel">
          <h3>Активные проекты</h3>
          {data.projects.length === 0 && <div className="tasks-empty">Проектов нет</div>}
          {data.projects.map((p) => (
            <Link
              to={`/tasks/projects/${p.id}`}
              key={p.id}
              style={{ display: 'block', textDecoration: 'none', color: 'inherit', padding: '10px 0', borderBottom: '1px solid #f3f4f6' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>{p.title}</strong>
                <StatusPill value={p.status} list={PROJECT_STATUSES} />
              </div>
              <div style={{ color: '#6b7280', fontSize: 13, marginTop: 4 }}>
                {p.team} · до {fmtDate(p.end_date)} · прогресс {p.progress}%
              </div>
              <div className="progress-bar" style={{ marginTop: 6 }}>
                <div className="progress-fill" style={{ width: `${p.progress}%` }} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
